import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * @typedef {Object} ProductDescriptionRefs
 * @property {HTMLElement} descriptionContainer
 */

/**
 * Keeps product description in sync with selected variant.
 * @extends {Component<ProductDescriptionRefs>}
 */
class ProductDescription extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateDescription = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const { descriptionContainer } = this.refs;
    const newProductDescription = event.detail.data.html.querySelector(
      `product-description[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newProductDescription) return;

    const newDescription = newProductDescription.querySelector('[ref="descriptionContainer"]');
    if (newDescription && descriptionContainer) {
      descriptionContainer.replaceWith(newDescription);
    }
  };
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription);
}
